var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1657",
    "data-name": "Groupe 1657",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1667",
    "data-name": "Groupe 1667",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_945",
    "data-name": "Trac\\xE9 945",
    d: "M22,3V5",
    transform: "translate(-14)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_946",
    "data-name": "Trac\\xE9 946",
    d: "M10,3V5",
    transform: "translate(6)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_947",
    "data-name": "Trac\\xE9 947",
    d: "M21,11H5",
    transform: "translate(-1 -3)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1064",
    "data-name": "Trac\\xE9 1064",
    d: "M5.5,9.5V6.31a.787.787,0,0,1,.762-.81H20.738a.787.787,0,0,1,.762.81V21.69a.787.787,0,0,1-.762.81H5.5",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1656",
    "data-name": "Groupe 1656",
    transform: "translate(-1363 -117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2967",
    "data-name": "Trac\\xE9 2967",
    d: "M-2530,4675v-5l4,5v-5",
    transform: "translate(3895 -4541)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2968",
    "data-name": "Trac\\xE9 2968",
    d: "M-2522,4679.666l2-1.666v5",
    transform: "translate(3899 -4549)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    x2: 2,
    transform: "translate(1372 132)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarN1);
export default __webpack_public_path__ + "static/media/calendar-n-1.8b2e48d6778b13a5fe97d406c6c2d511.svg";
export { ForwardRef as ReactComponent };